import { render, staticRenderFns } from "./PFGFruns.vue?vue&type=template&id=20c727c4"
import script from "./PFGFruns.vue?vue&type=script&lang=js"
export * from "./PFGFruns.vue?vue&type=script&lang=js"
import style0 from "./PFGFruns.vue?vue&type=style&index=0&id=20c727c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports